/**
 *  결제 관리 페이지명
 */
export const PAYMENT_PAGE_NAME = {
  PG_ROUTE: '결제 설정',
  PG_FEE: 'PG 수수료 관리',
};
